export interface ExamAttemptState {
  currentAttemptId: string | null;
}

export enum ExamAttemptActionType {
  SET_CURRENT_ATTEMPT = "examAttempt/setCurrentAttempt",
  CLEAR_CURRENT_ATTEMPT = "examAttempt/clearCurrentAttempt",
}
